<template>
  <div :class="`formulate-input-element  formulate-input-element--${context.type}`"
       :data-type="context.type"
  >

    <vue-tel-input
        type="text"
        v-model="phone_input_model"
        v-bind="context.attributes"
        :preferred-countries="['NZ','AU','GB','US']"
        :input-options="{ showDialCode: false }"
        @input="updatePhone"
        ></vue-tel-input>

  </div>
</template>

<script>
// https://iamstevendao.github.io/vue-tel-input/documentation/v2.html
// :enabled-country-code="true"
// :dropdown-options="{ disabledDialCode: true }"
// v-on:validate="validatePhone"

// // Layzload
const VueTelInput = () =>
    Promise.all([
      import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input'),
      import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input/dist/vue-tel-input.css'),
    ]).then(([{ VueTelInput }]) => VueTelInput);

// normal load
// import { VueTelInput } from 'vue-tel-input';
// import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  components: {
    VueTelInput,
  },
  props: {
    context: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
       phone_input_model: this.context.model ? this.context.model : null,
    };
  },
  mounted () {

  },
  computed: {
    model () {
      return this.context.model
    }
  },
  methods: {
    // WIP - cannot seem to re-format the phone number to strip the international from the input on restore...
    // As the watch functionality crushes it, but why phone_input_model = this.context.model work ??
    // TODO - add debounce on this
    // Update the number back to the form
    updatePhone(phone, data){
      // console.log(phone, data);
      this.context.model = data.number;
    }
  }
}
</script>

<style>
</style>
